import { Navigate, useLocation, useRoutes } from "react-router-dom";
import { APP_ROUTES, PUBLIC_PATHS } from "./routes";
import { useAuth } from "../contexts/auth";
import { useToasts } from "../contexts/toasts";
import { useEffect } from "react";
import { User } from "../api/User";
import Cookies from "js-cookie";
import { Billings } from "../api/Billings";

export default function AppRouter() {
  const { pathname } = useLocation();
  const {
    token,
    loggedUser,
    setLoggedUser,
    billingData,
    setBillingData,
    setIsBillingDataReady,
  } = useAuth();
  const { showToast } = useToasts();
  const routes = useRoutes(APP_ROUTES);

  useEffect(() => {
    if (token && !loggedUser) {
      User.getUserInfo(token).then(
        ({ data }) => {
          setLoggedUser(data);
          Cookies.set(
            window.__env.AUTH_USER_NAME || "get-move-user",
            JSON.stringify(data),
            { expires: 86400 }
          );
        },
        (err) => {
          showToast(
            "user-error",
            "Errore nella validazione dell'utente",
            "",
            "danger"
          );
        }
      );
    }
  }, [token, loggedUser, setLoggedUser, showToast]);

  useEffect(() => {
    if (loggedUser && !billingData) {
      Billings.getBillingDataByUserId(loggedUser.id).then(
        ({ data }) => {
          setBillingData(data.billing);
          setIsBillingDataReady(true);
        },
        (err) => {
          showToast(
            "billing-data-error",
            "Errore nel reperimento dei dati di fatturazione",
            "",
            "danger"
          );
        }
      );
    }
  }, [loggedUser, billingData, setBillingData, showToast, setIsBillingDataReady]);

  // Normalizza lo slash finale: "/informazioni-legali/" deve valere come
  // "/informazioni-legali", altrimenti il confronto esatto fallisce e la
  // pagina pubblica rimanda al login.
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";

  if (pathname !== "/login" && !token) {
    if (
      !PUBLIC_PATHS.includes(normalizedPath) &&
      !pathname.startsWith("/Share/")
    ) {
      return <Navigate to="/login" />;
    }
  } else if (pathname === "/login" && token) {
    return <Navigate to="/" />;
  }

  return routes;
}
